/* eslint-disable no-restricted-globals */
import { delay, call, put, select, takeLatest } from 'redux-saga/effects';

import * as apiItemLocation from '../../services/item/api_item_location';
import * as apiCommon from '../../services/apiCommon';
import * as sagaCommon from '../../sagas/sagasCommon';
import * as utilPreference from '../../services/preference/utilty_preference';
import * as inventoryHelper from '../../services/inventory/helper_inventory';
import {
  SET_ITEM_LOCATION_LIST,
  GET_ITEM_LOCATION_LIST_IN_PROGRESS,
  GET_ITEM_LOCATIONS,
  SAVE_ITEM_LOCATION,
  DELETE_ITEM_LOCATION,
  GET_ITEM_LOCATION,
  SET_MODAL_LOADING,
  INITIALIZE_DEFAULT_ITEM_LOCATION,
  APPLY_TO_ALL_ITEM_LOCATION
} from '../../constants/constant_action_types';
import {
  setItemLocation,
  setItemLocationPagination,
  closeItemLocationModal,
  clearItemLocation,
  showMessageModal,
  processingApplyToAllStore,
  doneProcessingApplyToAllStore
} from '../../actions/actionCreatorItemLocation';
import { fetchAssembledCustomFields } from '../../services/custom_field/api_custom_field';
import { getItemDetails } from '../../components/admin/item/modals/item_location/ItemLocationSelector';
import { STORE } from '../../constants/constant_location_types';
import { attachRecordListsToCustomForms } from '../../services/apiUtils';
import { getLocalDatetime } from '../../utils/local_date';
import moment from 'moment';

export function* saveItemLocationSaga(feathersApp) {
  yield takeLatest(SAVE_ITEM_LOCATION, callSaveItemLocation, feathersApp);
}

function* callSaveItemLocation(feathersApp, action) {
  try {
    yield sagaCommon.showProgressSaveRecord();
    const { tenant, user } = yield select();
    const { data } = action;
    const params = { tenant, user, data };
    const itemId = data.item_id;

    yield call(apiItemLocation.saveItemLocation, feathersApp, params);
    yield put({ type: GET_ITEM_LOCATIONS, filters: { item: itemId } });
    yield put(setItemLocation(data));
    yield sagaCommon.doneSaveRecord();

    yield put(closeItemLocationModal());
    yield put(clearItemLocation());
  } catch (e) {
    console.error(e.stack);
    yield sagaCommon.showErrorSaveRecord(e);
  }
}







export function* deleteItemLocationSaga(feathersApp) {
  yield takeLatest(DELETE_ITEM_LOCATION, callDeleteItemLocation, feathersApp);
}

function* callDeleteItemLocation(feathersApp, action) {
  try {
    const ok = confirm('Are you sure you want to delete this record?');
    if (!ok) return;

    yield sagaCommon.showProgressDeleteRecord();
    const { tenant, user } = yield select();
    const { data } = action;
    const params = { tenant, user, data };
    const itemId = data.item_id;
    yield call(apiItemLocation.deleteItemLocation, feathersApp, params);
    yield sagaCommon.doneDeleteRecord();
    yield put({ type: GET_ITEM_LOCATIONS, filters: { item: itemId } });
    yield put(closeItemLocationModal());
    yield put(clearItemLocation());
  } catch (e) {
    yield sagaCommon.showErrorDeleteRecord(e);
  }
}



export function* getItemLocationSaga(feathersApp) {
  yield takeLatest(GET_ITEM_LOCATION, callGetItemLocation, feathersApp);
}

function* callGetItemLocation(feathersApp, action) {
  try {
    const { id } = action;

    yield put({ type: SET_MODAL_LOADING, loading: true });

    if (id) {
      const {
        user,
        intl,
        tenant,
        item_location: {
          data: currentItemLocation,
          viewMode
        },
      } = yield select();

      if (currentItemLocation && currentItemLocation.id === id && !viewMode) {
        let customTabs = yield call(fetchAssembledCustomFields, feathersApp, 'item_location');
        customTabs = yield call(
          attachRecordListsToCustomForms,
          feathersApp,
          customTabs,
        );

        yield put(setItemLocation({ ...currentItemLocation, custom_tabs: customTabs }));
      } else {
        const itemLocation = yield call(apiItemLocation.getItemLocation, feathersApp, { user, id, viewMode });
    
        const preferenceParams = yield call(utilPreference.buildPreferenceQueryFromItemLocation, itemLocation, ['include_backorder'], tenant);
        const preferences = yield call(utilPreference.getPreferenceValues, feathersApp, { ...preferenceParams, intl });
        const { 
          back_order_quantity,
          on_hand,
          in_transit,
          average_cost,
          on_hand_total_cost,
          location_type
         } = itemLocation;
        const storeLocation = { 
          back_order_quantity,
          on_hand,
          in_transit,
          average_cost,
          on_hand_total_cost,
          location_type
        };
        itemLocation.sub_item_locations.unshift(storeLocation);
        itemLocation.sub_item_locations.forEach(subItemLocation => {
          const available = inventoryHelper.calculateQuantityAvailable(subItemLocation, preferences);
          subItemLocation.available = available;
          return subItemLocation;
        });

        itemLocation.custom_tabs = yield call(
          attachRecordListsToCustomForms,
          feathersApp,
          itemLocation.custom_tabs,
        );
    
        yield put(setItemLocation(itemLocation));
      }
    } else {
      const selectedItem = yield select(getItemDetails);
      let customTabs = yield call(fetchAssembledCustomFields, feathersApp, 'item_location');
      customTabs = yield call(
        attachRecordListsToCustomForms,
        feathersApp,
        customTabs,
      );

      const initialValues = {
        ...selectedItem,
        allow_manual_discount: true,
        custom_fields: {},
        custom_tabs: customTabs,
        location_type: STORE,
        loyalty_multiplier: 1,
      }

      yield put(setItemLocation(initialValues));
    }

    yield put({ type: SET_MODAL_LOADING, loading: false });
  } catch (e) {
    yield sagaCommon.showErrorDataById(e);
  }
}







export function* getItemLocationsSaga(feathersApp) {
  yield takeLatest(GET_ITEM_LOCATIONS, callGetItemLocations, feathersApp);
}

function* callGetItemLocations(feathersApp, action) {
  try {
    const { filters = {} } = action;
    const { item } = filters;
    const { requested_page, rows_per_page } = filters;
    if (!item) {
      yield put(setItemLocationPagination(1, 10, 0));
      yield put({ type: SET_ITEM_LOCATION_LIST, list: [] });
      return;
    }

    yield put({ type: GET_ITEM_LOCATION_LIST_IN_PROGRESS });
    const dataParams = {
      filters: { ...filters, location_type: 'store', available_from: getLocalDatetime(moment().toISOString())},
      list_type: 'item_location'
    };

    const storeItemLocationResult = yield call(apiCommon.getDocs, feathersApp, dataParams);
    const storeItemLocations = storeItemLocationResult.data;
  
    if(storeItemLocationResult.total){
      yield put(setItemLocationPagination(requested_page, rows_per_page, storeItemLocationResult.total));
    } else {
      yield put(setItemLocationPagination(1, 10, 0));
    }
    yield put({ type: SET_ITEM_LOCATION_LIST, list: storeItemLocations });

  } catch (e) {
    yield sagaCommon.showErrorListTable(e);
  }
}











export function* initializeDefaultItemLocationSaga(feathersApp) {
  yield takeLatest(INITIALIZE_DEFAULT_ITEM_LOCATION, callInitializeDefaultItemLocation, feathersApp);
}

function* callInitializeDefaultItemLocation(feathersApp, action) {
  try {
    const { user, tenant } = yield select();
    const { data } = action;

    const itemLocationId = data._id || data.id;
    if (!itemLocationId) {
      const subsidiaryId = data.subsidiary_id;
      const keySetting = 'default_new_item_location_from_default';
      const preferenceParams = {
        accountId: (tenant || {}).id,
        subsidiaryId,
        settings: [keySetting],
      };

      const preferences = yield call(utilPreference.getPreferenceValues, feathersApp, preferenceParams);
      const currencyId = data.currency_id;
      const itemId = data.item_id;
      if (preferences[keySetting] && currencyId && itemId) {

        const defaultItemLocation = yield call(apiItemLocation.getDefaultItemLocation, feathersApp, { user, currencyId, itemId });
        console.log('defaultItemLocation', defaultItemLocation);
        if (!defaultItemLocation) return;
        yield put({ type: SET_MODAL_LOADING, loading: true });

        const newItemLocation = {
          ...defaultItemLocation,
          ...data,
        };
        delete newItemLocation._rev;
        delete newItemLocation._id;
        delete newItemLocation.id;
        delete newItemLocation.created_by;
        delete newItemLocation.created_datetime;
        delete newItemLocation.last_updated_by;
        delete newItemLocation.last_updated_datetime;
        delete newItemLocation.on_hand;
        delete newItemLocation.in_transit;
        delete newItemLocation.average_cost;
        delete newItemLocation.on_hand_total_cost;
        delete newItemLocation.default_item_location;
        newItemLocation.supplier_ids = (newItemLocation.supplier || []).map(supplier => { return supplier._id });
        newItemLocation.output_device_type_ids = (newItemLocation.output_device_type || []).map(output_device_type => { return output_device_type._id });

        yield put(setItemLocation(newItemLocation));
        yield put({ type: SET_MODAL_LOADING, loading: false });

      }
    }

  } catch (e) {
    // yield put(sagaCommon.showErrorDataById(e));
  }
}



export function* applyToAllItemLocationSaga(feathersApp) {
  yield takeLatest(APPLY_TO_ALL_ITEM_LOCATION, callApplyToAllItemLocation, feathersApp);
}

function* callApplyToAllItemLocation(feathersApp, action) {
  try {
    const { id, item_id } = action;
    yield put(showMessageModal());
    yield put(processingApplyToAllStore());

    const result = yield call(apiItemLocation.generateItemLocation, feathersApp, { id });
    yield delay(1000);
    yield put(doneProcessingApplyToAllStore(result.total_processed, true));
    yield delay(1000);
    yield put({ type: GET_ITEM_LOCATIONS, filters: { item: item_id } });

    yield put(closeItemLocationModal());
    yield put(clearItemLocation());
    
  } catch (e) {
    console.error(e.stack);
    yield put(doneProcessingApplyToAllStore(0));
    yield sagaCommon.showErrorSaveRecord(e);
  }
}